/* eslint-disable max-len */
export const descriptionAreaMockedData = {
  "description": "<p><strong>Trash Kit - 3D AssetKit</strong></p><p>Realistic trash needs variety. With this AssetKit package over 700 single assets are at your disposal to get just that - Photorealistic Trash, Garbage, Rubble, you name it.</p><p>The assets are usable in any 3D Package and are as optimized as possible while preserving managable polygon count and shape. You are free to use them in your 3D scenes, VFX and Games, change them to your liking or kitbash and scatter them in every way that comes to your mind.</p><p>You are free to pick from 18 different categories from tiny cigarettes and dry grass to large props containing multiple sub-assets. Each category contains between 8 and 61 props so you have enough material even when filling up vast spaces. </p><p>Manual set dressing offers the most control and is fun with these assets. However nobody wants to scatter everything by hand, therefore Trash Biomes are available for the Blender Addon GeoScatter, which is amazing for professional scatterers. If you want to scatter with Blender On-Board-Tools - no problem, I got you covered too. There is a Geometry NodesSetup included that might be helpful for you. Find the GeoNodes tutorial at the end of the asset video.</p><p>Everything is ready to render with Blender Cycles and EEVEE. Of course you can use it with any renderer you prefer. The urban environment example scene from the video will be included in case you want to try out the assets there.</p><p>As you can see in the wireframe renders the assets are fairly low poly for the level of detail. For import in Game Engines I have included seperate files with the meshes triangulated and located in the origin. (“*_TriangulatedAtOrigin”, FBX Pack)</p><p>All textures are PBR based and HighRes. You will also find two HDR environments used in the previs renderings included. Textures are in PBR Metal/Roughness workflow.</p><p>Please have a look at the renderings and see if assets and wireframe suit your needs.</p><p><strong>Blender GeoScatter Addon - Biomes Available</strong></p><p>The Kit has preset Biomes for the amazing Blender addon GeoScatter. Add the TrashKit.blend to your Blender Asset Libraries in the Preferences. Now from GeoScatter you can install the included .scatpack file like any other ScatPack.</p><p><strong>-Content-</strong></p><p><strong>Scenes:</strong></p><ul>\n<li>    TrashKit ( 715 Assets )</li>\n<li>    TrashKit_TriangulatedAtOrigin ( for instance based workflow or Game Engines)</li>\n</ul><p><strong>Meshes:</strong></p><ul>\n<li>    Base_Trash_Assets (61 Variations)</li>\n<li>    Grass_Assets (16 Variations)</li>\n<li>    Rubble_Assets (31 Variations)</li>\n<li>    Cans (Beverage and Food) (65 Variations)</li>\n<li>    Cans_Paint_Assets (48 Variations)</li>\n<li>    Bottles_Assets (43 Variations)</li>\n<li>    Generic_Trash_Assets (83 Variations)</li>\n<li>    Wood_Splinter_Assets (34 Variations)</li>\n<li>    Buckets_Assets (32 Variations)</li>\n<li>    Bags_Assets (32 Variations)</li>\n<li>    Boxes_Assets (74 Variations)</li>\n<li>    Smokables_Assets (40 Variations)</li>\n<li>    Barrels_Assets (38 Variations)</li>\n<li>    Tires_Assets (10 Variations)</li>\n<li>    Prefabs_Medium_Assets (53 Variations)</li>\n<li>    Prefabs_Large_Assets (9 Variations)</li>\n<li>    Prefabs_SmallTrash_Assets (6 Variations)</li>\n<li>    Additional_Assets (42 Variations)</li>\n</ul><p><strong>Textures:</strong></p><ul>\n<li>    BaseColor / Albedo</li>\n<li>    Normal GL</li>\n<li>    Normal DX</li>\n<li>    Roughness - PBR Metal/Roughness Workflow</li>\n<li>    Metallic - wherever necessary</li>\n<li>    Masks for Opacity</li>\n</ul><p><strong>Textures additional:</strong></p><ul>\n<li>    Example scene textures</li>\n<li>    HDR Environment - 2 Variants</li>\n</ul><p><strong>Blender Utility:</strong></p><ul><li>    Geometry Nodes Setup “TrashKit_GeoNodes”. A Tutorial you will find in the Trashkit Video</li></ul><p>Enjoy rendering!</p>",
  "relatedTags": [
    {
      "id": 47128925,
      "text": "trash",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/trash",
    },
    {
      "id": 47128926,
      "text": "junk",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/junk",
    },
    {
      "id": 47128927,
      "text": "garbage",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/garbage",
    },
    {
      "id": 47128928,
      "text": "rubble",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/rubble",
    },
    {
      "id": 47128930,
      "text": "waste",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/waste",
    },
    {
      "id": 47128931,
      "text": "brick",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/brick",
    },
    {
      "id": 47128932,
      "text": "barrel",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/barrel",
    },
    {
      "id": 47128933,
      "text": "can",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/can",
    },
    {
      "id": 47128936,
      "text": "bin",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/bin",
    },
    {
      "id": 47128939,
      "text": "wasteland",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/wasteland",
    },
    {
      "id": 47128940,
      "text": "urban",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/urban",
    },
    {
      "id": 47128941,
      "text": "environment",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/environment",
    },
    {
      "id": 47128943,
      "text": "street",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/street",
    },
    {
      "id": 47128945,
      "text": "city",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/city",
    },
    {
      "id": 47128948,
      "text": "container",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/container",
    },
    {
      "id": 47128949,
      "text": "box",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/box",
    },
    {
      "id": 47128950,
      "text": "tire",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/tire",
    },
    {
      "id": 47128951,
      "text": "grass",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/grass",
    },
    {
      "id": 47128954,
      "text": "trashbag",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/trashbag",
    },
    {
      "id": 47128955,
      "text": "bottle",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/bottle",
    },
    {
      "id": 50870507,
      "text": "various",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/various",
    },
    {
      "id": 50870508,
      "text": "models",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/models",
    },
    {
      "id": 50870509,
      "text": "various models",
      "active": true,
      "url": "https://www.cgtrader.com/3d-models/various-models",
    },
  ],
  "breadcrumbs": [
    {
      "title": "VR / AR / low-poly 3D Models",
      "url": "/low-poly-3d-models",
      "isActive": false,
    },
    {
      "title": "Various",
      "url": "https://www.cgtrader.com/3d-models/various",
      "isActive": false,
    },
    {
      "title": "Various models",
      "url": "https://www.cgtrader.com/3d-models/various-models",
      "isActive": false,
    },
    {
      "title": "Trash Kit - 3D AssetKit VR / AR / low-poly 3d model",
      "url": "https://www.cgtrader.com/3d-models/various/various-models/trashkit-3d-assetkit",
      "isActive": true,
    },
  ],
}
